import { createActionsWithPrefix } from "../../helperfunctions/action";

export const MetaDataActions = createActionsWithPrefix("METADATA/", {
    REQUEST: "REQUEST",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
});